import { gql } from '@apollo/client';
import { TEMPLATE_FIELDS_FRAGMENT } from './fragments';

/**
 * Create new template
 */
export const CREATE_TEMPLATE = gql`
  ${TEMPLATE_FIELDS_FRAGMENT}
  mutation CreateTemplate($tenantId: String!, $input: GqlCreateTemplateInput!) {
    createTemplate(tenantId: $tenantId, input: $input) {
      ...TemplateFields
    }
  }
`;

/**
 * Update template status
 */
export const UPDATE_TEMPLATE_STATUS = gql`
  ${TEMPLATE_FIELDS_FRAGMENT}
  mutation UpdateTemplateStatus($tenantId: String!, $templateId: String!, $input: GqlUpdateTemplateStatusInput!) {
    updateTemplateStatus(tenantId: $tenantId, templateId: $templateId, input: $input) {
      ...TemplateFields
    }
  }
`;

/**
 * Submit template for approval workflow
 */
export const SUBMIT_TEMPLATE_FOR_APPROVAL = gql`
  mutation SubmitTemplateForApproval($tenantId: String!, $templateId: String!) {
    submitTemplateForApproval(tenantId: $tenantId, templateId: $templateId) {
      requiresApproval
      requiredApprovals
      deadlineHours
      roles
      confidenceThreshold
      currentConfidence
      additionalReviewRequired
      additionalReviewReason
    }
  }
`;

/**
 * Publish approved template
 */
export const PUBLISH_TEMPLATE = gql`
  ${TEMPLATE_FIELDS_FRAGMENT}
  mutation PublishTemplate($tenantId: String!, $templateId: String!) {
    publishTemplate(tenantId: $tenantId, templateId: $templateId) {
      ...TemplateFields
    }
  }
`;

/**
 * Archive template
 */
export const ARCHIVE_TEMPLATE = gql`
  ${TEMPLATE_FIELDS_FRAGMENT}
  mutation ArchiveTemplate($tenantId: String!, $templateId: String!) {
    archiveTemplate(tenantId: $tenantId, templateId: $templateId) {
      ...TemplateFields
    }
  }
`;

/**
 * Generate primitive instances from template
 */
export const GENERATE_INSTANCES_FROM_TEMPLATE = gql`
  mutation GenerateInstancesFromTemplate($tenantId: String!, $templateId: String!, $runtimeContext: JSON) {
    generateInstancesFromTemplate(tenantId: $tenantId, templateId: $templateId, runtimeContext: $runtimeContext) {
      templateId
      templateVersion
      instances
      generatedAt
      generatedBy
    }
  }
`;

/**
 * Validate template against 11-phase validation pipeline
 */
export const VALIDATE_TEMPLATE = gql`
  mutation ValidateTemplate($tenantId: String!, $templateId: String!) {
    validateTemplate(tenantId: $tenantId, templateId: $templateId) {
      valid
      errors
      warnings
      validatedAt
    }
  }
`;

/**
 * Create child template from parent with overrides
 */
export const CREATE_CHILD_TEMPLATE = gql`
  ${TEMPLATE_FIELDS_FRAGMENT}
  mutation CreateChildTemplate($tenantId: String!, $parentTemplateId: String!, $name: String!, $version: String!, $overrides: JSON) {
    createChildTemplate(tenantId: $tenantId, parentTemplateId: $parentTemplateId, name: $name, version: $version, overrides: $overrides) {
      ...TemplateFields
    }
  }
`;
